import React from 'react'
import tw, {styled} from 'twin.macro'
import DefaultStyles from './DefaultStyles'

const Wrapper = styled.div`
  ${tw`px-8 pt-4 pb-16 md:(px-12 pt-4 pb-16 grid grid-cols-12 gap-x-3)`}

  > h3 > a {
    ${tw`flex items-center justify-center border border-gray-light py-2 px-4 no-underline w-40 hocus:(bg-gray-lightest border-white text-gray-darkest transition-colors) text-sm rounded-md`}
  }

  > * {
    ${tw`md:col-start-3 md:col-span-8 lg:col-start-4 lg:col-span-6`}
  }

  *:last-child {
    ${tw`mb-0`}
  }

  > h2 {
    ${tw`text-2xl`}
  }

  > blockquote > h3::before {
    content: open-quote;
    margin-left: -0.75rem;
  }
  > blockquote > h3::after {
    content: close-quote;
  }
  > blockquote {
    ${tw`font-serif`}
  }
  > blockquote > h3 {
    ${tw` font-normal p-10 pb-0 lg:p-12 lg:pb-0 text-xl md:text-xl lg:text-2xl lg:w-9/12 break-words`}
  }

  > blockquote > p {
    ${tw`text-gray pl-12`}
  }

  /* & {
    blockquote {
      ${tw``}
    }
    p {
      ${tw``}
    }
  } */
`

const Content = (props) => {
  if (props.markdown) {
    return (
      <DefaultStyles>
        <Wrapper
          {...props}
          dangerouslySetInnerHTML={{
            __html: props.markdown.childMarkdownRemark.html,
          }}
        />
      </DefaultStyles>
    )
  }
  return (
    <DefaultStyles>
      <Wrapper {...props}>{props.children}</Wrapper>
    </DefaultStyles>
  )
}

export default Content
